export const MONTHS = [
	'janeiro',
	'fevereiro',
	'marco',
	'abril',
	'maio',
	'junho',
	'julho',
	'agosto',
	'setembro',
	'outubro',
	'novembro',
	'dezembro',
] as const;

export type Month = (typeof MONTHS)[number];

export const MONTH_LABELS: Record<Month, string> = {
	janeiro: 'Janeiro',
	fevereiro: 'Fevereiro',
	marco: 'Março',
	abril: 'Abril',
	maio: 'Maio',
	junho: 'Junho',
	julho: 'Julho',
	agosto: 'Agosto',
	setembro: 'Setembro',
	outubro: 'Outubro',
	novembro: 'Novembro',
	dezembro: 'Dezembro',
};

export const MONTH_NUMBERS: Record<Month, number> = {
	janeiro: 0,
	fevereiro: 1,
	marco: 2,
	abril: 3,
	maio: 4,
	junho: 5,
	julho: 6,
	agosto: 7,
	setembro: 8,
	outubro: 9,
	novembro: 10,
	dezembro: 11,
};
